export const environment = {
  production: true,
  apiURLPrefix: 'https://inmessage.alcmeon.com/prod/api/',
  websocketURL: 'wss://inmessage-ws.alcmeon.com/subscribe',
  xhrWithCredentials: true,
  sentryDsn: 'https://0bf765148ea626ce51de7c0ad4d9573f@sentry.prod.alcmeon.net/10',
};
